import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import login from './views/login'


//我的信息
import myInfo from './views/my/index.vue'

// 商品页面
import product from './views/product/index.vue'
import goodsInfo from './views/product/goodsInfo.vue'

// 订货页面
import order from './views/order/index.vue'
import orderDetail from './views/order/orderdetail.vue'
import addOrder from './views/order/add.vue'
import editOrder from './views/order/edit.vue'
import send from './views/send/send.vue'
import sendDetail from './views/send/sdetail.vue'
import orderSummary from './views/order/summary.vue'
import addSend from './views/send/addsend.vue'
import addProSend from './views/send/addprosend.vue'

import payment from './views/finance/payment/list.vue'

import customReport from './views/finance/report/customerReport.vue'
import otherReport from './views/finance/report/other.vue'
import needReport from './views/finance/report/report.vue'

import customer from './views/customer/index.vue'
import addCustomer from './views/customer/add.vue'
// 购物车
import car from './views/car/index.vue'
// 消息
import message from './views/message/index.vue'
import sysMessageDetail from './views/message/sysdetail.vue'


// 仓库相关
import store from './views/store/index.vue'
import storeDetail from './views/store/detail.vue'
import storeSummary from './views/store/summary.vue'
import storeEnter from './views/store/enter.vue'
import storeExit from './views/store/exit.vue'
import storeChange from './views/store/change.vue'

// 采购
import purchase from './views/purchase/index.vue'
import purchaseAdd from './views/purchase/add.vue'
import refund from './views/purchase/refund.vue'
import refundAdd from './views/purchase/addre.vue'
import purchaseSummary from './views/purchase/summary.vue'
import purchaseDetail from './views/purchase/detail.vue'
import ppick from './views/purchase/pick.vue'
import addPick from './views/purchase/addpick.vue'
import pEnter from './views/purchase/enter.vue'
import addEnter from './views/purchase/addenter.vue'
import pStock from './views/purchase/stock.vue'


import Empty from './views/empty.vue'
import Temp from './views/temp.vue'

import panel from './views/panel/panel.vue'
import panel2 from './views/panel/panel2.vue'
import statistics from './views/statistics/index.vue'

import Bom from './views/bom/bom.vue'
// 设置
// import set from './views/set/index.vue'

Vue.use(Router)

export default new Router({
	mode:'hash',
	routes: [{
			path: '/login',
			component: login,
			name: '登录'
		},{
			path:'/statistics',
			name:'报表',
			component:statistics,
			
			beforeEnter:((to,from,next)=>{
				if(from.fullPath=='/'){
					let token = localStorage.getItem("token");
					if(token){
						next(`/temp?url=${to.fullPath}`)
					}else{
						next('/login')
					}
				}else{
					next();
				}
			}),
		},{
			path: '/temp',
			name: '',
			component: Temp
		},{
			path: '/',
			component: Home,
			redirect: 'product',

			beforeEnter:((to,from,next)=>{
				if(from.fullPath=='/'){
					let token = localStorage.getItem("token");
					if(token){
						next(`/temp?url=${to.fullPath}`)
					}else{
						next('/login')
					}
				}else{
					next();
				}
			}),

			children: [{
				path: '/product',
				name: '商品',
				component: product
			},{
				path: '/goodsInfo',
				component: goodsInfo,
				name: '商品详情'
			},{
				path: '/order',
				name: '订货单',
				component: order
			},{
				path: '/empty',
				name: '中间页',
				component: Empty
			},{
				path: '/message',
				name: '消息',
				component: message
			},{
				path: '/sysMessageDetail',
				name: '系统公告详情',
				component: sysMessageDetail
			},{
				path: '/myInfo',
				name: '个人信息',
				component: myInfo
			},{
				path: '/car',
				name: '购物车',
				component: car
			},{
				path: '/payment',
				name: '财务',
				component: payment
			},{
				path: '/customer',
				name: '客户',
				component: customer
			},{
				path: '/needReport',
				name: '应收报表',
				component: needReport
			},{
				path: '/otherReport',
				name: '其他收入报表',
				component: otherReport
			},{
				path: '/customReport',
				name: '客户报表',
				component: customReport
			},{
				path: '/addCustomer',
				name: '新增客户',
				component: addCustomer
			},{
				path: '/addOrder',
				name: '新增订单',
				component: addOrder
			},{
				path: '/orderDetail',
				name: '订单详情',
				component: orderDetail
			},{
				path: '/addSend',
				name: '新增发货',
				component: addSend
			},{
				path: '/addProSend',
				name: '新增产品发货',
				component: addProSend
			},{
				path: '/editOrder',
				name: '编辑订单',
				component: editOrder
			},{
				path: '/store',
				name: '库存明细',
				component: store
			},{
				path: '/storeDetail',
				name: '出入库明细',
				component: storeDetail
			},{
				path: '/storeSummary',
				name: '出入库汇总',
				component: storeSummary
			},{
				path: '/storeEnter',
				name: '商品入库',
				component: storeEnter
			},{
				path: '/storeExit',
				name: '商品出库',
				component: storeExit
			},{
				path: '/storeChange',
				name: '库存调拨',
				component: storeChange
			},{
				path: '/send',
				name: '发货信息',
				component: send
			},{
				path: '/sendDetail',
				name: '发货详情',
				component: sendDetail
			},{
				path: '/orderSummary',
				name: '订单统计',
				component: orderSummary
			},{
				path: '/purchase',
				name: '采购单',
				component: purchase
			},{
				path: '/refund',
				name: '采购退货单',
				component: refund
			},{
				path: '/purchaseAdd',
				name:'新增采购单',
				component: purchaseAdd,
			},{
				path: '/refundAdd',
				name:'新增采购退货单',
				component: refundAdd,
			},{
				path: '/purchaseSummary',
				name:'采购出入库',
				component: purchaseSummary,
			},{
				path: '/purchaseDetail',
				name:'采购单明细',
				component: purchaseDetail,
			},{
				path: '/ppick',
				name:'领料出库',
				component: ppick,
			},{
				path: '/addPick',
				name:'新增领料出库',
				component: addPick,
			},{
				path: '/pEnter',
				name:'材料入库',
				component: pEnter,
			},{
				path: '/addEnter',
				name:'新增材料入库',
				component: addEnter,
			},{
				path: '/panel',
				name:'生产车间情况看板',
				component: panel,
			},{
				path: '/panel2',
				name:'统计报表',
				component: panel2,
			},{
				path: '/pStock',
				name:'原材料库存',
				component: pStock,
			},{
				path: '/Bom',
				name:'BOM清单',
				component: Bom,
			}
			]
		},
	]
})
